var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"homePage"},[_c(_vm.userCover,{tag:"component",attrs:{"info":_vm.coverInfo}}),_c('q-inner-loading',{attrs:{"showing":_vm.visible}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }